/**
 * Truncates text to a specified limit.
 *
 * @param text The text (string/number) to truncate.
 * @param limit The character limit. Defaults to 15.
 * @returns Truncated text with ellipsis if needed.
 */
export function truncateText(text: string | number | null | undefined, limit: number = 15): string {
    if (text === null || text === undefined) return '';
    const str = text.toString();
    return str.length > limit ? str.slice(0, limit) + '...' : str;
}
